module.exports = "<div *ngIf='unconformity' style=\"display: flex;align-items: center; justify-content: space-between;\">\n  <span>{{unconformity.description || unconformity.unconformity || 'N/A'}}</span>\n  <i class=\"material-icons\" [ngStyle]=\"{'color': getColor(unconformity.criticality)}\"  >warning</i>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/unconformity-item/unconformity-item.component.html
// module id = ../../../../../src/app/shared/component/unconformity-item/unconformity-item.component.html
// module chunks = main